import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { motion } from 'framer-motion';
import { IconButton } from 'conversional-components';
import { ComponentClass, mediaBreakpointDown, sizes } from 'conversional-theme';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
import ImageWrapper from '../imageWrapper';
import { generateClasses } from '../../utilities/components/styles';
import classNames from 'classnames';
var ExitIntentComponent = function (_a) {
    var close = _a.close, htmlId = _a.htmlId, onClick = _a.onClick, display = _a.display, showModal = _a.showModal, backgroundVideo = _a.backgroundVideo, backdrop = _a.backdrop, isInternal = _a.isInternal, backdropStyles = _a.backdropStyles, overlayStyles = _a.overlayStyles, contentStyles = _a.contentStyles, _b = _a.hideCloseButton, hideCloseButton = _b === void 0 ? false : _b, children = _a.children;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var styles = generateClasses(function () { return Styles(theme, backdrop); })();
    var content = (_jsx("div", { id: htmlId, className: classNames(styles.backdrop, ComponentClass(backdropStyles)), onClick: close, children: _jsxs("div", { className: classNames(styles.overlay, ComponentClass(overlayStyles)), onClick: function (e) { return e.stopPropagation(); }, children: [backgroundVideo && (_jsx("video", { autoPlay: true, className: styles.backgroundVideo, loop: true, src: backgroundVideo })), _jsxs("div", { className: styles.inner, children: [display && (_jsx(ImageWrapper, { src: display, onClick: onClick, alt: "Start", className: styles.image })), _jsx("div", { className: classNames(styles.content, ComponentClass(contentStyles)), children: children }), !hideCloseButton && _jsx("div", { className: styles.close, children: _jsx(IconButton, { close: close }) })] })] }) }));
    if (isInternal)
        return showModal ? content : null;
    return _jsx(_Fragment, { children: showModal && _jsx(motion.div, { children: content }, "conversional-exitintent-modal") });
};
var Styles = function (theme, backdrop) {
    var _a, _b, _c, _d;
    return {
        backdrop: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: backdrop || 'rgba(0,0,0,0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999999,
            cursor: 'pointer'
        },
        overlay: (_a = {
                font: theme.typo.fonts.regular,
                minHeight: 300,
                maxWidth: 1100,
                position: 'relative',
                width: 'auto'
            },
            _a[mediaBreakpointDown(sizes.sm)] = {
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100vh',
                overflow: 'auto'
            },
            _a),
        close: (_b = {
                position: 'absolute',
                zIndex: 3,
                top: -12,
                right: -12
            },
            _b[mediaBreakpointDown(sizes.sm)] = {
                top: '12px !important',
                right: '12px !important'
            },
            _b),
        image: {
            cursor: 'pointer',
            width: '100%',
            height: 'auto'
        },
        backgroundVideo: {
            position: 'absolute',
            width: '100%',
            objectFit: 'cover',
            height: '100%',
            zIndex: 1
        },
        inner: (_c = {
                cursor: 'initial',
                position: 'relative',
                zIndex: 2,
                margin: '2rem'
            },
            _c[mediaBreakpointDown(sizes.sm)] = {
                margin: '1rem'
            },
            _c),
        content: (_d = {},
            _d[mediaBreakpointDown(sizes.sm)] = {
                maxWidth: '100% !important',
                paddingTop: 40,
                background: '#FFF',
                // To avoid chaning all configs
                ':nth-child(n) > div': {
                    maxWidth: '100%'
                },
                ':nth-child(n) > div > div > div': {
                    width: '100% !important',
                    maxWidth: '100%'
                },
                ':nth-child(n) > div > div > div > img': {
                    width: '100%',
                    height: 'unset'
                }
            },
            _d)
    };
};
export default ExitIntentComponent;
